import { gql } from "@apollo/client";

export const GET_FIRST_PURCHASE_EVENT_STATUS = gql`
  query GetFirstPurchaseEventStatus {
    me {
      id
      firstPurchaseEventStatus {
        isEligible
        remainingDays
      }
    }
  }
`;

export const MARK_FIRST_PURCHASE_EVENT_SEEN = gql`
  mutation MarkFirstPurchaseEventSeen {
    markFirstPurchaseEventSeen {
      ok
      error
    }
  }
`;

export const ISSUE_FIRST_PURCHASE_COUPON = gql`
  mutation IssueFirstPurchaseCoupon($type: FirstPurchaseCouponType!) {
    issueFirstPurchaseCoupon(type: $type) {
      success
      couponId
      message
    }
  }
`;
